import {
	BRAND_ACCENT,
	FORM_CONTROL_BORDER,
	FORM_CONTROL_BORDER_RADIUS,
	FORM_INPUT_FONT_SIZE,
} from "@constants/brand.colors";
import type { InputFieldSize } from "../types/inputfield";
import { AUTH_INPUT_SIZE } from "@components/common/AuthLayout/authConstants";

/** Institute-portal auth fields — padding drives height; no fixed 48px shell */
export const AuthTextFieldStyles = (
	isClickable: boolean | undefined,
	size: InputFieldSize = AUTH_INPUT_SIZE,
	error?: boolean,
) => {
	let height: string = AUTH_INPUT_SIZE.height;
	let padding: string = AUTH_INPUT_SIZE.padding;

	if (typeof size === "object" && size !== null) {
		height = size.height ?? height;
		padding = size.padding ?? padding;
	}

	const borderColor = error ? "#d32f2f !important" : `${FORM_CONTROL_BORDER} !important`;
	const activeBorderColor = error ? "#d32f2f !important" : `${BRAND_ACCENT} !important`;

	return {
		cursor: isClickable ? "pointer" : "text",

		"& .MuiOutlinedInput-root": {
			borderRadius: FORM_CONTROL_BORDER_RADIUS,
			backgroundColor: "#ffffff",
			overflow: "hidden",
		},

		"&.Mui-disabled .MuiOutlinedInput-root": {
			backgroundColor: "#ffffff",
			opacity: 1,
			cursor: "not-allowed",
		},

		"& input": {
			color: "#4b5563",
			cursor: isClickable ? "pointer" : "text",
			padding,
			minHeight: "unset",
			height,
			fontFamily: "Poppins, sans-serif",
			paddingLeft: "10px",
			fontSize: FORM_INPUT_FONT_SIZE,
			fontWeight: "400",
			backgroundColor: "transparent",
			borderRadius: 0,
			"&.Mui-disabled": {
				WebkitTextFillColor: "#6B7280",
				color: "#6B7280",
				opacity: 1,
				cursor: "not-allowed",
			},
			"&::placeholder": {
				color: "#9ca3af",
				opacity: 1,
				fontSize: FORM_INPUT_FONT_SIZE,
			},
			"&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus": {
				WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
				WebkitTextFillColor: "#4b5563",
				caretColor: "#4b5563",
				transition: "background-color 9999s ease-out 0s",
			},
		},

		"& fieldset": {
			borderColor,
			borderWidth: 1,
			borderRadius: FORM_CONTROL_BORDER_RADIUS,
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderWidth: 1,
			borderRadius: FORM_CONTROL_BORDER_RADIUS,
		},
		"&:hover fieldset": {
			borderColor: activeBorderColor,
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: activeBorderColor,
			borderWidth: 1,
		},
		"&.Mui-focused fieldset": {
			borderColor: activeBorderColor,
			borderWidth: "1px !important",
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: activeBorderColor,
			borderWidth: "1px !important",
		},

		"&.Mui-error fieldset, &.Mui-error .MuiOutlinedInput-notchedOutline": {
			borderColor: "#d32f2f !important",
			borderWidth: "1px !important",
		},
		"&.Mui-error:hover fieldset, &.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "#d32f2f !important",
		},
		"&.Mui-error.Mui-focused fieldset, &.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "#d32f2f !important",
			borderWidth: "1px !important",
		},

		"& .MuiInputAdornment-root svg": {
			color: "#8b8b8b",
		},
		"&.Mui-focused .MuiInputAdornment-root svg": {
			color: "#8b8b8b",
		},
		"&.Mui-error .MuiInputAdornment-root svg": {
			color: "#d32f2f",
		},
		"& .MuiInputAdornment-positionStart": {
			marginRight: "0px",
		},
		"& .MuiInputAdornment-positionEnd": {
			marginLeft: "0px",
		},

		"& .MuiInputBase-input::placeholder": {
			color: "#9ca3af",
			opacity: 1,
			fontSize: FORM_INPUT_FONT_SIZE,
		},

		"& .MuiFormHelperText-root": {
			marginTop: "4px",
			fontSize: "11px",
			marginLeft: "0px",
			fontFamily: "Poppins, sans-serif",
			color: error ? "#d32f2f" : "#6B7280",
			lineHeight: 1,
		},
		"& .MuiFormHelperText-root.Mui-error": {
			color: "#d32f2f",
		},
	};
};
